"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _EmptyState = _interopRequireDefault(require("web/shared/components/EmptyState"));
var _InternalPageHeader = _interopRequireDefault(require("web/shared/components/InternalPageHeader"));
var _Icon = require("web/shared/icons/Icon");
var _SearchBar = _interopRequireDefault(require("web/shared/components/SearchBar"));
var _Color = _interopRequireDefault(require("web/shared/utils/Color"));
var _IconCard = _interopRequireDefault(require("web/shared/icons_gallery/IconCard"));
var _IconColorPicker = _interopRequireDefault(require("web/shared/icons_gallery/IconColorPicker"));
var _iconGallery = require("web/shared/icons_gallery/iconGallery");
var _styles = require("web/shared/icons_gallery/styles");
var _consolePage = require("web/shared/console/consolePage.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The /internal/icons page: a live gallery of the Kanyami shared icon
* library. Every registered glyph shows its name, its search hints, a big
* showcase drawing, and the full size-token ramp; hovering a card (or
* tapping / pressing Enter) loops the glyph's progress animation, across
* every size at the same time. The search bar filters by name or by hint
* (the everyday words a glyph is registered with), and the color-picker
* button beside it holds a color vector every rendered icon receives — so
* multi-slot glyphs can be judged in color, and hover animations keep
* whatever palette is picked. Both live in the page's address, so a reload
* or a shared link opens on the same search and palette, and the header and
* the search stay at the top while the cards scroll beneath them. Drawn
* inside whatever gate the product's console puts around it.
*/
function IconsView() {
  const _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
    _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  const _useMemo = (0, _react.useMemo)(() => (0, _iconGallery.galleryStateFrom)(searchParams), [searchParams]),
    query = _useMemo.query,
    pickedHexes = _useMemo.hexes; // Replacing rather than pushing, so typing a search is not a trail of
  // history entries to step back through.
  const showState = (0, _react.useCallback)(next => {
    setSearchParams((0, _iconGallery.galleryParamsFor)(next), {
      replace: true
    });
  }, [setSearchParams]);
  const setQuery = next => showState({
    query: next,
    hexes: pickedHexes
  });
  const setPickedHexes = update => showState({
    query,
    hexes: update(pickedHexes)
  }); // The picked hexes as the Color vector every icon receives.
  const colorVector = (0, _react.useMemo)(() => pickedHexes.map(hex => _Color.default.fromHex(hex)), [pickedHexes]);
  const visibleNames = _Icon.ICON_NAMES.filter(name => (0, _iconGallery.matchesQuery)(name, query));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_consolePage.consolePage.inset, _consolePage.consolePage.roomBelow, _styles.styles.page)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.stickyTop)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InternalPageHeader.default, {
        title: "Icons",
        context: null,
        backTo: null,
        backLabel: null
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.searchRow)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchBar.default, {
          value: query,
          onChange: setQuery,
          placeholder: "Search icons (name or hint)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconColorPicker.default, {
          pickedHexes: pickedHexes,
          onChange: setPickedHexes,
          colorVector: colorVector
        })]
      }))]
    })), visibleNames.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.grid)), {}, {
      children: visibleNames.map(name => /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconCard.default, {
        name: name,
        colors: colorVector
      }, name))
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyState.default, {
      title: "No icons match",
      description: "Try another word \u2014 or add the missing hint to the library's hints registry."
    })]
  }));
}
var _default = exports.default = IconsView;